import { create } from "zustand";
import { authApi } from "../api/auth";
import { buildTheme, applyTheme } from "../themes";

function _applyUserTheme(user) {
  if (user?.entity_theme) applyTheme(buildTheme(user.entity_theme));
}

const useAuthStore = create((set, get) => ({
  user: null,
  isAuthenticated: false,
  loading: true,

  // Called once on app mount to rehydrate from localStorage
  init: async () => {
    const token = localStorage.getItem("access_token");
    if (!token) {
      set({ loading: false });
      return;
    }
    try {
      const { data } = await authApi.me();
      _applyUserTheme(data);
      set({ user: data, isAuthenticated: true, loading: false });
    } catch {
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      set({ user: null, isAuthenticated: false, loading: false });
    }
  },

  login: async (email, password) => {
    const { data } = await authApi.login(email, password);
    localStorage.setItem("access_token", data.access_token);
    localStorage.setItem("refresh_token", data.refresh_token);
    _applyUserTheme(data.user);
    set({ user: data.user, isAuthenticated: true });
  },

  register: async (payload) => {
    const { data } = await authApi.register(payload);
    localStorage.setItem("access_token", data.access_token);
    localStorage.setItem("refresh_token", data.refresh_token);
    _applyUserTheme(data.user);
    set({ user: data.user, isAuthenticated: true });
  },

  // Called by the /auth/callback page after SSO redirect
  loginWithToken: (accessToken, refreshToken) => {
    localStorage.setItem("access_token", accessToken);
    if (refreshToken) localStorage.setItem("refresh_token", refreshToken);
    authApi.me().then(({ data }) => {
      _applyUserTheme(data);
      set({ user: data, isAuthenticated: true });
    });
  },

  logout: async () => {
    try { await authApi.logout(); } catch { /* ignore */ }
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    set({ user: null, isAuthenticated: false });
  },

  updateUser: (patch) => set((s) => ({ user: { ...s.user, ...patch } })),

  togglePin: async (projectId) => {
    const { data } = await authApi.togglePin(projectId);
    set({ user: data });
  },
}));

export default useAuthStore;
